import { createUseStyles } from "react-jss";
import { SPACING } from "../../../constants/styleGuide";


export const AddBudgetByUTBMSStyles = createUseStyles({
  budgetTypePhase: {
    paddingTop: SPACING.s16,
    '& .MuiToolbar-root': {
      display: "none"
    },
  },
  addPhase: {
    padding: SPACING.s16,
    backgroundColor: "#f8f8f8",
  },
  cursorPointer: {
    cursor: "pointer",
  },
})
